/* DON'T EDIT THIS FILE: edit original and run build again */ import { promisePipe } from "../../framework/data-pipe/promise-pipe.ts";
import { usePipe } from "../../framework/firebase/use-pipe.ts";
import { fetchTenantHandlerOrNull } from "../../framework/tenant-collection/tenant.ts";

const createFetchTenantPromisePipe = (tenant: string) => {
  return promisePipe(fetchTenantHandlerOrNull(tenant));
};

export const useFetchTenantHandler = (tenant: string) => {
  return usePipe(createFetchTenantPromisePipe, [tenant]);
};
